import React, { ChangeEventHandler } from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { Services } from '@/services/services'
import { useNavigate, useParams } from 'react-router-dom'

import './Activate.module.css'
import { Machine } from '@/services/model/machine'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'
import { ActivateQRCodeForm, ActivateQRCodeFormData } from '@/components/forms/qrcode/Activate'
import { useForm } from 'react-hook-form'

var roles = ['super_admin', 'company_admin']

interface Dict {
  id: string
  label: string
}

export const QRActivate = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const navigate = useNavigate();
  let tid = useParams().id
  const [machines, setMachines] = useState<Machine[]>()
  const [machine, setMachine] = useState<Machine>()

  useEffect(() => {
    fetch("/api/schema/machines").then((resp) => {
      return resp.json()
    }).then((data) => {
      setMachines(data)
    });
  }, [])

  const form = useForm<ActivateQRCodeFormData>({
    defaultValues: {}
  })

  if (!roles.includes(session.user.role)) {
    return <div className='permission-denide'>{session.translates.for('errors.no_permissions')}</div>
  }

  const onSubmit = async (formData: ActivateQRCodeFormData) => {
    fetch('/api/schema/qr/activate', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: tid,
        machineId: formData.machineId
      })
    }).then(() => {
      navigate(`/qr/tag/${tid}`)
    });
  }

  return <LoggedInPageLayout services={services} session={session} pageName='activate-tag'>
    <ActivateQRCodeForm 
      form={form}
      services={services}
      onSubmit={onSubmit} 
      translates={session.translates}
      formName='activateqrcode'
      readOnly={false} />
  </LoggedInPageLayout >
}

    // <select
    //   value={machine?.id}
    //   onChange={(event) => {
    //     setMachine(machines?.find(entity => event.target.value == String(entity.id)))
    //   }}>
    //   <option key={undefined} value={undefined}>-</option>
    //   {machines?.map((option) => (
    //     <option key={option.id} value={option.id} selected={option.id === machine?.id}>
    //       {option.name}
    //     </option>
    //   ))}
    // </select>
    // <button disabled={machine?.id == undefined} onClick={() => {
    //   fetch('/api/schema/qr/activate', {
    //     method: 'POST',
    //     headers: {
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify({
    //       id: tid,
    //       machineId: machine?.id
    //     })
    //   }).then(() => {
    //     navigate(`/qr/tag/${tid}`)
    //   });
    // }}>Activate</button>